import { Link } from "react-router-dom";
import { formatDate } from "../lib/format";

export function ArticleCard({ article, size = "md", showImage = true }) {
  const isHero = size === "hero";
  const isLg = size === "lg";

  return (
    <article className="group" data-testid={`article-card-${article.slug}`}>
      <Link to={`/noticia/${article.slug}`} className="block">
        {showImage && article.cover_image && (
          <div className="img-zoom aspect-[16/10] bg-zinc-100 mb-3 overflow-hidden">
            <img src={article.cover_image} alt={article.title} className="w-full h-full object-cover" loading="lazy" />
          </div>
        )}
        <div>
          {article.category && (
            <span className="overline text-red-700" data-testid="article-category">{article.category.name}</span>
          )}
          <h3 className={`font-serif-display font-semibold leading-tight text-zinc-900 headline-hover mt-1 ${
            isHero ? "text-3xl sm:text-4xl lg:text-5xl" : isLg ? "text-2xl lg:text-3xl" : size === "sm" ? "text-base" : "text-lg lg:text-xl"
          }`}>
            {article.title}
          </h3>
          {article.subtitle && (isHero || isLg) && (
            <p className="font-body text-zinc-700 mt-2 text-base lg:text-lg leading-snug">{article.subtitle}</p>
          )}
          <div className="font-sans-ui text-xs text-zinc-500 mt-2 flex items-center gap-2">
            {article.author && <span>Por {article.author.name}</span>}
            {article.author && article.published_at && <span>·</span>}
            {article.published_at && <time dateTime={article.published_at}>{formatDate(article.published_at)}</time>}
          </div>
        </div>
      </Link>
    </article>
  );
}

export function ArticleListItem({ article }) {
  return (
    <article className="py-4 border-b border-zinc-200 flex gap-4" data-testid={`list-${article.slug}`}>
      {article.cover_image && (
        <Link to={`/noticia/${article.slug}`} className="img-zoom flex-shrink-0 w-32 h-24 overflow-hidden">
          <img src={article.cover_image} alt={article.title} className="w-full h-full object-cover" loading="lazy" />
        </Link>
      )}
      <div className="flex-1">
        <Link to={`/noticia/${article.slug}`}>
          {article.category && <span className="overline text-red-700">{article.category.name}</span>}
          <h3 className="font-serif-display text-xl font-semibold leading-tight headline-hover mt-1">{article.title}</h3>
          {article.subtitle && <p className="font-body text-sm text-zinc-700 mt-1 line-clamp-2">{article.subtitle}</p>}
          <div className="font-sans-ui text-xs text-zinc-500 mt-2">
            {article.author && <>Por {article.author.name} · </>}
            {article.published_at && <time>{formatDate(article.published_at)}</time>}
          </div>
        </Link>
      </div>
    </article>
  );
}
